import * as React from "react";
import {useState, useEffect} from "react";
import jfetch from "../../utils/jfetch";
import Button from "../core/Button"
import toast from "../../utils/toast";
import Card from "../core/Card";


function OrderProduct(props){

  const [phone, setPhone] = useState(props.userContext.user.data.attributes.phoneNumber)
  const [email, setEmail] = useState(props.userContext.user.data.attributes.email)
  const [info, setInfo] = useState('')

  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  
  const set_val = (newVal, updateFunction) => {
    updateFunction(newVal)
  }

  // useEffect(() => {

  // }, [])

  async function send_ticket(){
    setLoading(true)
    await create_ticket(
      props.userContext.user.data.attributes.name, 
      props.userContext.organization.data.attributes.title,
      props.product.label
    )
    setLoading(false)
    setDone(true)
  }

  async function create_ticket(user_name, org_name, product_name){
    const params = {
      companyid: "CharTec",
      subject: `CORE - a non purchasable product was ordered`,
      message: `A CORE product request form was submitted:
                \n ${user_name} from ${org_name} requested to purchase ${product_name}
                \n Phone: ${phone}
                \n Email: ${email}
                \n Member Message: ${info}
                \n Product Link: https://core.chartec.net/order_product?product_id=${props.product.id}`,
      board: "sales",
      recid: 2
    };
    return await jfetch.post('/api/ct_cw/create_ticket', params);
  }

  if(done){
    return (
      <div className="container">
        <Card>
          <div className="row">
            <div className="col-lg-12">
              <h2 style={{color:'black'}} className="text-center">
                Thank you for your request! 🎉🎊 <br/>
                A CharTec representative will be reaching out to you shortly.
              </h2>
            </div>
          </div>
        </Card> 
      </div>
    )
  }

  return(
    <div className="container">
      <Card>
      <div className="row">
        <div className="col-lg-12">
          <h2 style={{color:'black'}}>{props.product.label}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-9">
          <img className="img-responsive" src={props.productImage} />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-9">
          <h3 style={{color:'black'}}>{props.product.message}</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <label>Phone</label>
          <input type="text" value={phone} onChange={(e) => set_val(e.target.value, setPhone)} placeholder="661-333-5555"/>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <label>Email</label>
          <input type="text" value={email} onChange={(e) => set_val(e.target.value, setEmail)} placeholder="you@company.com"/>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <label>Additional Info</label>
          <br/>
          <textarea value={info} onChange={(e) => set_val(e.target.value, setInfo)} rows={6} style={{width:'400px'}} placeholder="Tell us more..." />          
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <Button color="primary" loading={loading} onClick={send_ticket}>Place Order</Button>
        </div>
      </div>
      </Card>
    </div>
  );
}



export default OrderProduct


// WEBPACK FOOTER //
// ./app/javascript/components/pages/OrderProduct.tsx